module.exports = __webpack_public_path__ + "img/4-ancho.6958a690.jpg";